(function () {
  if (window.__quickAddSizesInitialized) return;
  window.__quickAddSizesInitialized = true;

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.classList || !target.classList.contains('quick-add-sizes__size-input')) return;

    var wrapper = target.closest('.quick-add-sizes');
    if (!wrapper) return;

    var variantInput = wrapper.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.value = target.value;
    }

    var isAvailable = target.dataset.available === 'true';

    var addButton = wrapper.querySelector('.quick-add-sizes__button');
    if (addButton) {
      addButton.disabled = !isAvailable;
    }

    var labels = wrapper.querySelectorAll('.quick-add-sizes__size');
    labels.forEach(function (label) {
      label.classList.remove('is-selected');
    });

    var selectedLabel = target.closest('.quick-add-sizes__size');
    if (selectedLabel) {
      selectedLabel.classList.add('is-selected');
    }

    // Selecting an available size adds it to the cart immediately, like the
    // reference site: no separate click on "Add to cart" is required.
    if (isAvailable && variantInput && variantInput.form) {
      window.__lastAddedProductHandle = wrapper.dataset.productHandle || null;
      variantInput.form.requestSubmit();
    }
  });
})();
